export { default } from './ActionAreaView';
